import React, { useState, memo } from 'react';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

const ReferAndEarnAppBar = (props) => {
    const classes = commonStyle();

    const [colorSelected] = useState(classes.svg_white);

    return (
        <>
            <svg
                style={{
                    enableBackground: 'new 0 0 512 512',
                    width: '36px'
                }}
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 9C8 7.89543 8.89543 7 10 7H18C19.1046 7 20 7.89543 20 9V10H24H25V11V28V29H24H4H3V28V11V10H4H8V9ZM5 12H8V14H5V12ZM20 12V14H23V12H20ZM8 17V16H5V27H23V16H20V17C20 18.1046 19.1046 19 18 19H10C8.89543 19 8 18.1046 8 17ZM13 9V12H10V14H13V17H15V14H18V12H15V9H13ZM40 23C40 25.7625 37.7625 28 35 28C32.2375 28 30 25.7625 30 23C30 20.2375 32.2375 18 35 18C37.7625 18 40 20.2375 40 23ZM25 35.3333C25 31.7867 31.6625 30 35 30C38.3375 30 45 31.7867 45 35.3333V41H27H25H14H13V40V33.4142L9.70711 36.7071L8.29289 35.2929L13.2929 30.2929L14 29.5858L14.7071 30.2929L19.7071 35.2929L18.2929 36.7071L15 33.4142V39H25V35.3333Z"
                    className={colorSelected}
                />
                <path d="M11 21H17V28H11V21Z" className={colorSelected} />
            </svg>
        </>
    );
};

export default memo(ReferAndEarnAppBar);
